module.exports = __webpack_public_path__ + "static/media/indepthinterview.42203133.pdf";